import { atomFamily } from "recoil";
import { MapFeature } from "./types/MapFeature";
import { MapIdentifierType } from "./types/MapIdentifierType";


export const mapFeaturesAtom = atomFamily<MapFeature[], MapIdentifierType>({
    key: 'mapFeaturesState',
    default: []
});